'use strict';

angular.module('webAgro1App').controller('AppCtrl', function ($scope, $rootScope, LoadingService) {
  $rootScope.bodyClass = 'force-print';

  LoadingService.showLoading();
  $rootScope.initialize.then(function() {
    LoadingService.hideLoading();

    try {
      var configuration = getConfiguration().match(/(https?):\/\/(.+):(\d+)/);
      $scope.configuration = {
        scheme: configuration[1],
        servers: configuration[2],
        port: configuration[3],
        description: getConfigurationDescription()
      };
      $scope.qr = new QRious({
        element: document.querySelector('#qrcode'),
        value: JSON.stringify($scope.configuration),
        size: 400
      });
    } catch (error) {
      console.error(error);
    }
  });
});
